<!-- Selection -->
<p-multiSelect
  #multiSelect
  [styleClass]="
    'form-control ' +
    (class || '') +
    ' ' +
    selectClasses +
    (required && multiSelectModel.invalid && multiSelectModel.touched
      ? ' is-invalid'
      : '')
  "
  [ngClass]="{
    'is-invalid':
      required && multiSelectModel.invalid && multiSelectModel.touched,
  }"
  [showToggleAll]="true"
  [emptyMessage]="
    isLoading
      ? ('Loading' | translate) + '...'
      : ('No result found' | translate)
  "
  [emptyFilterMessage]="
    isLoading
      ? ('Loading' | translate) + '...'
      : ('No result found' | translate)
  "
  [options]="optionsArray"
  [optionValue]="getKeyField()"
  [optionLabel]="displayField"
  [filter]="true"
  [filterBy]="searchField"
  [id]="key"
  [ngModel]="values ?? []"
  (ngModelChange)="valuesChange.emit($event)"
  [name]="key ?? ''"
  #multiSelectModel="ngModel"
  [placeholder]="
    isLoading ? ('Loading' | translate) + '...' : placeholder || ''
  "
  [loading]="isLoading"
  [showClear]="clearButton"
  [required]="required"
  appendTo="body"
  [disabled]="disabled"
  (onFilter)="lazyLoad ? onFilter($event) : null"
  (onShow)="lazyLoad && loadedOptions.length === 0 ? loadMore() : null"
>
  <!-- Dropdown list item -->
  <ng-template let-item pTemplate="item">
    <ng-container
      *ngIf="resolvedTemplate; else simpleItem"
      [ngTemplateOutlet]="resolvedTemplate.template"
      [ngTemplateOutletContext]="{ $implicit: item }"
    />
    <ng-template #simpleItem>
      {{ displayParser ? displayParser(item) : (item | get: displayField) }}
    </ng-template>
  </ng-template>

  <!-- Selected chips/label area -->
  <ng-template let-values pTemplate="selectedItems">
    <ng-container *ngIf="values?.length; else emptyPlaceholder">
      <ng-container *ngFor="let value of values">
        <ng-container
          *ngIf="resolvedSelectedTemplate; else simpleSelected"
          [ngTemplateOutlet]="resolvedSelectedTemplate.template"
          [ngTemplateOutletContext]="{ $implicit: value }"
        />
        <ng-template #simpleSelected>
          <span class="mr-1">{{
            displayParser ? displayParser(value) : (value | get: displayField)
          }}</span>
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-template #emptyPlaceholder>{{ placeholder }}</ng-template>
  </ng-template>
</p-multiSelect>

<!-- Loading indicator for lazy loading -->
<div *ngIf="lazyLoad && isLoading" class="text-center p-2">
  <small>{{ 'Loading' | translate }}...</small>
</div>

<!-- Errors -->
<div
  *ngIf="multiSelectModel.errors && multiSelectModel.errors['required']"
  class="invalid-feedback"
>
  {{ requiredError }}
</div>
